import { render, staticRenderFns } from "./i-image-viewer.vue?vue&type=template&id=fa4b2c0a&scoped=true&"
import script from "./i-image-viewer.vue?vue&type=script&lang=js&"
export * from "./i-image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./i-image-viewer.vue?vue&type=style&index=0&id=fa4b2c0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4b2c0a",
  null
  
)

export default component.exports